import type { ApiConfig } from "./types";
import { getMainHost } from "../utils";
// API配置文件
export const API_CONFIG: ApiConfig = {
  // 基础URL
  BASE_URL: `https://gforum.${getMainHost()}/api/index.php`,

  // 控制器名称
  CONTROLLERS: {
    USER: "user",
    THREAD: "thread",
    REPLY: "reply",
    FORUM: "forum",
    FAVORITE: "favorite",
    SEARCH: "search",
    LIKE: "like",
    SIGN: "signin",
    FILE_UPLOAD: "fileupload",
    VIDEO: "sign",
    BIND: "userrole",
    SHARE_THREAD: "share_thread",
    TRANSLATION: "translation",
    SYSTEM: "system",
    PAGE: "page",
    POINT_REWARD: "point_reward",
  },

  // 操作名称
  ACTIONS: {
    // 用户相关
    TOKEN_LOGIN: "tokenLogin",
    LOGOUT: "logout",
    INFO: "info",
    FINFO: "finfo",
    LIST: "list",
    UPDATE_REAL_NAME: "updateRealname",
    GET_REAL_NAME_RECORD: "getUsernameChangeHistory",
    FOLLOW: "follow",
    FOLLOW_LIST: "getFollowList",
    UNFOLLOW: "unfollow",
    SEARCH: "search",
    UPDATE_AVATAR: "updateUserAvatar",
    SIGN: "signin",

    // 帖子相关
    DETAIL: "detail",
    CREATE: "create",
    USER_THREADS: "getUserThreads",
    DELETE: "delete",
    GET_TAG_INFO: "getTagInfo",

    // 论坛相关
    FORUM_INFO: "info",
    REPLY_DETAIL: "getRepliesByToppid",
    FORUM_SIGN: "sign",

    // 收藏/点赞相关
    ADD: "add",
    REMOVE: "remove",

    // 搜索相关
    THREAD: "searchThreads",
    USER: "searchUsers",
    HOT_KEYWORDS: "getHotKeywords",

    // 文件上传相关
    UPLOAD_IMG: "uploadImg",
    GET_KEY: "getSignature",

    // 通知相关
    NOTIFICATION_COUNT: "getNotificationCounts",
    NOTIFICATION_DETAIL: "getNotificationDetails",
    FOLLOW_NOTIFICATION: "getFollowerNotificationCount",

    // 用户绑定相关
    SERVER_LIST: "getServerList",
    ROLE_LIST: "getUserRoleInfo",
    BIND_ROLE: "bindUserRole",

    // 分享帖子相关
    GET_CHANNELS: "getChannels",
    SUBMIT_SHARE: "submitShare",

    // 翻译相关
    DO: "do",

    // 系统相关
    LANGUAGE: "language",
    GET_EXT_PARAMS: "getExtParams",

    // 单一页面相关
    GET_PAGE_THREAD: "getPageThread",

    // 积分奖励相关
    GET_TASKS: "getTasks",
    GET_REWARDS: "getRewards",
    EXCHANGE: "exchange",
    EXCHANGE_RECORDS: "exchangeRecords",
    TASK_ACTION: "taskAction",
  },
};

// 构建API URL的辅助函数
export const buildApiUrl = (
  controller: string,
  action: string,
  params: Record<string, any> = {}
): string => {
  const url = new URL(API_CONFIG.BASE_URL);
  // 过滤掉params中值为undefined的参数
  Object.keys(params).forEach((key) => {
    if (params[key] === undefined) {
      delete params[key];
    }
  });

  // 添加控制器和动作参数
  url.searchParams.set("controller", controller);
  url.searchParams.set("action", action);

  // 添加其他参数
  Object.keys(params).forEach((key) => {
    url.searchParams.set(key, String(params[key]));
  });

  return url.toString();
};
